import type { RootState } from 'js/src/libs/RootState';

export function isFontListLoading(state: RootState): boolean {
    return state.fonts.isLoading;
}

export function areFontsLoaded(state: RootState): boolean {
    const list = getFontList(state);
    return list.get('allIds').size > 0;
}

export function getFontList(state: RootState) {
    return state.fonts.list;
}
